import _ from 'lodash';
import * as types from '../actions/actionTypes';
import initialState from './initialState';
import {
  filterStudyList,
  returnInitialStudy,
  getStudyFromStudies,
  getStudyFamilyIdForGivenProductNo,
  arrayToObject,
} from '../util/CommonUtils';
// import { isStudyAvailable } from '../util/preferenceUtils';
import {
  CROSSTAB_FEATUREID,
  QUICKREPORTS_FEATUREID,
  DATAHAUL_FEATUREID,
  STORIES_FEATUREID,
  MME_FEATUREID,
  CORRCLUSTER_FEATUREID,
  // GEOMAPPING_FEATUREID,
  DV_DEFAULT_VALUE,
} from '../constants';

export default (state = initialState.studies, action) => {
  switch (action.type) {
    case types.GET_STUDIES:
      if (action.payload && action.payload.status === 200) {
        const studyList = (action.payload.data !== undefined && action.payload.data.length > 0) ?
        action.payload.data : [];
        const supportResourcesInitialStudy = studyList[0].sl[0];
        const userPreferences = _.cloneDeep(action.userPreferences);

        const latestStudies = {
          ...state.latestStudies,
        };
        if (latestStudies._ct === undefined) {
          latestStudies._ct = {
            productNo: supportResourcesInitialStudy.pn,
            study: supportResourcesInitialStudy.st,
            studyDescription: supportResourcesInitialStudy.sd,
          };
        }
        if (latestStudies._qr === undefined) {
          latestStudies._qr = {
            productNo: supportResourcesInitialStudy.pn,
            study: supportResourcesInitialStudy.st,
            studyDescription: supportResourcesInitialStudy.sd,
          };
        }
        if (latestStudies._dh === undefined) {
          latestStudies._dh = {
            productNo: supportResourcesInitialStudy.pn,
            study: supportResourcesInitialStudy.st,
            studyDescription: supportResourcesInitialStudy.sd,
          };
        }
        if (latestStudies._st === undefined) {
          latestStudies._st = {
            productNo: supportResourcesInitialStudy.pn,
            study: supportResourcesInitialStudy.st,
            studyDescription: supportResourcesInitialStudy.sd,
          };
        }
        let crosstabInitialStudy = returnInitialStudy(studyList, CROSSTAB_FEATUREID);
        let quickReportsInitialStudy = returnInitialStudy(studyList, QUICKREPORTS_FEATUREID);
        let datahaulInitialStudy = returnInitialStudy(studyList, DATAHAUL_FEATUREID);
        let storiesInitialStudy = returnInitialStudy(studyList, STORIES_FEATUREID);
        const caCInitialStudy = returnInitialStudy(studyList, CORRCLUSTER_FEATUREID);
        const mmeInitialStudy = returnInitialStudy(studyList, MME_FEATUREID);

        if (userPreferences._ct._ds !== -1) {
          crosstabInitialStudy = getStudyFromStudies(
            filterStudyList(action.payload.data, CROSSTAB_FEATUREID), userPreferences._ct._ds);
        }

        if (userPreferences._qr._ds !== -1) {
          quickReportsInitialStudy = getStudyFromStudies(
            filterStudyList(action.payload.data, QUICKREPORTS_FEATUREID), userPreferences._qr._ds);
        }

        if (userPreferences._dh._ds !== -1) {
          datahaulInitialStudy = getStudyFromStudies(
            filterStudyList(action.payload.data, DATAHAUL_FEATUREID), userPreferences._dh._ds);
        }

        if (userPreferences._st._ds !== -1) {
          storiesInitialStudy = getStudyFromStudies(
            filterStudyList(action.payload.data, STORIES_FEATUREID), userPreferences._st._ds);
        }
        // const geoMapInitialStudy = returnInitialStudy(studyList, GEOMAPPING_FEATUREID);
        // const crosstabWeightTypes = crosstabInitialStudy.cw ? crosstabInitialStudy.cw[0] : {};
        const ctStudyFamilyID = getStudyFamilyIdForGivenProductNo(
          crosstabInitialStudy.pn,
          studyList
        );
        const crosstabWeightTypes =
          typeof userPreferences._ct._sw === 'string' ||
          userPreferences._ct._sw.wt === undefined
            ? crosstabInitialStudy.cw[0]
            : userPreferences._ct._sw;
        crosstabWeightTypes.sd = ctStudyFamilyID;
        const qrStudyFamilyID = getStudyFamilyIdForGivenProductNo(
          quickReportsInitialStudy.pn,
          studyList
        );
        const quickreportsWeightTypes =
          typeof userPreferences._qr._sw === 'string' ||
          userPreferences._qr._sw.wt === undefined
            ? quickReportsInitialStudy.cw[0]
            : userPreferences._qr._sw;
        quickreportsWeightTypes.sd = qrStudyFamilyID;
        const dhStudyFamilyID = getStudyFamilyIdForGivenProductNo(
          datahaulInitialStudy.pn,
          studyList
        );
        const datahaulWeightTypes =
          typeof userPreferences._dh._sw === 'string' ||
          userPreferences._dh._sw.wt === undefined
            ? datahaulInitialStudy.cw[0]
            : userPreferences._dh._sw;
        datahaulWeightTypes.sd = dhStudyFamilyID;
        const stStudyFamilyID = getStudyFamilyIdForGivenProductNo(
          storiesInitialStudy.pn,
          studyList
        );
        const storiesWeightTypes =
          typeof userPreferences._st._sw === 'string' ||
          userPreferences._st._sw.wt === undefined
            ? storiesInitialStudy.cw ?  storiesInitialStudy.cw[0] : {}
            : userPreferences._st._sw;
        storiesWeightTypes.sd = stStudyFamilyID;
        const mmeWeightTypes = mmeInitialStudy.cw ? mmeInitialStudy.cw[0] : {};
        if (
          !_.isEmpty(crosstabWeightTypes) &&
          crosstabWeightTypes.dv === undefined
        ) {
          crosstabWeightTypes.dv = DV_DEFAULT_VALUE;
        }
        if (!_.isEmpty(quickreportsWeightTypes) && quickreportsWeightTypes.dv === undefined) {
          quickreportsWeightTypes.dv = DV_DEFAULT_VALUE;
        }
        if (!_.isEmpty(datahaulWeightTypes) && datahaulWeightTypes.dv === undefined) {
          datahaulWeightTypes.dv = DV_DEFAULT_VALUE;
        }
        if (!_.isEmpty(storiesWeightTypes) && storiesWeightTypes.dv === undefined) {
          storiesWeightTypes.dv = DV_DEFAULT_VALUE;
        }
        if (!_.isEmpty(mmeWeightTypes) && mmeWeightTypes.dv === undefined) {
          mmeWeightTypes.dv = DV_DEFAULT_VALUE;
        }
        return {
          ...state,
          studies: action.payload.data,

          isConnectStudySubscribed:
            action.payload.data.filter(({ desc }) =>
              /Connect/gi.test(desc),
            ).length > 0,
          mmeStudy: {
            ...mmeInitialStudy,
          },
          // geomapStudy: {
          //   ...geoMapInitialStudy,
          // },

          crosstabStudy: {
            ...crosstabInitialStudy,
          },
          quickReportsStudy: {
            ...quickReportsInitialStudy,
          },
          datahaulStudy: {
            ...datahaulInitialStudy,
          },
          visahaulStudy: {
            ...storiesInitialStudy,
          },
          cacStudy: {
            ...caCInitialStudy,
          },
          supportResourcesStudy: {
            ...supportResourcesInitialStudy,
          },
          trendStudies: [],
          hasCrosstabStudies: !(_.isEmpty(crosstabInitialStudy)),
          hasEssentialStudies: !(_.isEmpty(crosstabInitialStudy)),
          hasQuickReportsStudies: !(_.isEmpty(quickReportsInitialStudy)),
          hasDatahaulStudies: !(_.isEmpty(datahaulInitialStudy)),
          hasStoriesStudies: !(_.isEmpty(storiesInitialStudy)),
          hasMMEStudies: !(_.isEmpty(mmeInitialStudy)),
          hasCaCStudies: !(_.isEmpty(caCInitialStudy)),
          latestStudies,
          crosstabWeightTypes,
          quickreportsWeightTypes,
          datahaulWeightTypes,
          storiesWeightTypes,
          // hasGeoMapStudies: !(_.isEmpty(geoMapInitialStudy)),
          mmeWeightTypes,
        };
      }
      return {
        ...state,
        studies: action.payload,
        crosstabStudy: [],
        trendStudies: [],
      };
    case types.UPDATE_WEIGHT_TYPES: {
      let moduleType = action.payload.moduleType === 'visahaul' ? 'stories' : action.payload.moduleType;
      if(moduleType === 'DATAHUB_BUILD') {
        moduleType = 'Datahub';
      }
      moduleType = moduleType ? moduleType.toLowerCase() : 'crosstab';
      const weightTypeObj = { ...action.payload.weightTypeObj };
      if (!_.isEmpty(weightTypeObj) && weightTypeObj.dv === undefined) {
        weightTypeObj.dv = DV_DEFAULT_VALUE;
      }
      return {
        ...state,
        [`${moduleType}WeightTypes`]: weightTypeObj,
      };
    }
    case types.NO_ESSENTIALS_STUDIES:
      return {
        ...state,
        hasEssentialStudies: action.payload,
        hasCrosstabStudies: action.payload,
        hasQuickReportsStudies: action.payload,
        hasDatahaulStudies: action.payload,
        hasStoriesStudies: action.payload,
        hasMMEStudies: action.payload,
        hasCaCStudies: action.payload,
      };
    case types.UPDATE_MODULE_STUDY: {
      let moduleType = action.moduleType === 'visahaul' ? 'stories' : action.moduleType;
      moduleType = moduleType ? moduleType.toLowerCase() : 'crosstab';
      const weightType = action.updatedWeightType ? action.updatedWeightType : action.study.cw[0];
      if (!_.isEmpty(weightType) && weightType.dv === undefined) {
        weightType.dv = DV_DEFAULT_VALUE;
      }
      return {
        ...state,
        [`${action.moduleType}Study`]: { ...action.study },
        // crosstabStudy: { ...action.study },
        // quickReportsStudy: { ...action.study },
        [`${moduleType}WeightTypes`]: { ...weightType },
        trendStudies:
          action.moduleType === 'crosstab' && state.trendStudies
            ? state.trendStudies.filter(
                item => item.pn !== action.study.pn,
              )
            : state.trendStudies,
      };
    }
    case types.SET_TREND_STUDIES:
      return { ...state, trendStudies: [...action.trendStudies] };
    case types.CLEAR_TREND_STUDIES:
      return { ...state, trendStudies: [] };
    case types.UPDATE_COMMON_STUDY:
      return {
        ...state, lastStudySelected: action.study.lastStudySelected,
      };
    case types.GET_SC_STUDY: {
      // Incase of catalyst even weight type 2 or more is set to 1
      if (action.study.wt > 1) {
        action.study.wt = 1;
      }
      return {
        ...state,
        salesCatalystStudies: action.payload,
        salesCatalystStudy: { ...action.study,
        studyFamilyId: getStudyFamilyIdForGivenProductNo(action.study.pn, action.payload) },
        hasSCStudies: true,
      };
    }
    case types.NO_SC_STUDIES:
      return {
        ...state,
        hasSCStudies: action.payload,
      };
    case types.NO_BC_STUDIES:
      return {
        ...state,
        hasBCStudies: action.payload,
      };
    case types.SET_SC_STUDY: {
      // Incase of catalyst even weight type 2 or more is set to 1
      if (action.payload.wt > 1) {
        action.payload.wt = 1;
      }
      return {
        ...state,
        salesCatalystStudy: { ...action.payload,
          studyFamilyId: getStudyFamilyIdForGivenProductNo(action.payload.pn, state.salesCatalystStudies) },
      };
    }
    case types.GET_360_STUDY: {
      // Incase of catalyst even weight type 2 or more is set to 1
      if (action.study.wt > 1) {
        action.study.wt = 1;
      }
      return {
        ...state,
        insight360studies: action.payload,
        insight360study: { ...action.study,
        studyFamilyId: getStudyFamilyIdForGivenProductNo(action.study.pn, action.payload) },
        hasBCStudies: true,
      };
    }
    case types.SET_360_STUDY: {
      // Incase of catalyst even weight type 2 or more is set to 1
      if (action.payload.wt > 1) {
        action.payload.wt = 1;
      }
      return {
        ...state,
        insight360study: { ...action.payload,
        studyFamilyId: getStudyFamilyIdForGivenProductNo(action.payload.pn, state.insight360studies) },
      };
    }
    // case types.FILTER_STUDIES_BASED_ON_WEIGHT_TYPE: {
    //   let weightTypeStudies = [];
    //   _.forEach(action.payload, studyList => {
    //     const studies = studyList.sl.filter(el => {
    //       return el.wt > 2;
    //     });
    //     weightTypeStudies = [...weightTypeStudies, ...studies];
    //   });
    //   return {
    //     ...state,
    //     weightTypeStudies,
    //   };
    // }
    case types.GET_LATEST_STUDIES: {
      return {
        ...state,
        latestStudies: action.payload || {},
      };
    }
    case types.GET_GEOMAPPING_STUDY: {
      // if (action.payload[0].studies[0].weightType > 2) {
      //   action.payload[0].studies[0].weightType = 1;
      // }
      const geoMapStudy = action.payload.data[0].sl[0];
      const geoWeightTypes = geoMapStudy.cw ? geoMapStudy.cw[0] : {};
      if (!_.isEmpty(geoWeightTypes) && geoWeightTypes.dv === undefined) {
        geoWeightTypes.dv = DV_DEFAULT_VALUE;
      }
      return {
        ...state,
        geoMapStudies: action.payload.data,
        geoMapStudy,
        hasGeoMapStudies: true,
        geoWeightTypes,
      };
    }
    case types.NO_GEOMAPPING_STUDIES:
      return {
        ...state,
        hasGeoMapStudies: action.payload,
      };

    case types.GET_FOOTNOTES: {
      const footNote = `${action.moduleType}FootNotes`;
      let footNoteList = {}
      footNoteList = arrayToObject(action.payload, 'footnoteCode');
      return {
        ...state,
        [footNote]: footNoteList,
      }
    }
    default:
      return state;
  }
}
/** Study attributes and their descriptions
 *
|    Old Attributes          |    New Attributes    |    Comments             |
|----------------------------|----------------------|-------------------------|
|    id                      |    id                | Study Group ID          |
|    desc                    |    sgd               | Study Group Description |
|    trendType               |    tt                | Trend Type              |
|    permissions             |    pm                | Permissions             |
|    studyList               |    sl                | Study List              |
|    productNo               |    pn                | Product No              |
|    study                   |    st                | Study ID                |
|    studyDescription        |    sd                | Study Description       |
|    studyYear               |    sy                | Study Year              |
|    studyRelease            |    sr                | Study Release           |
|    fieldStart              |    fs                | Field Start Date        |
|    fieldEnd                |    fe                | Field End Date          |
|    divisor                 |    dv                | Divisor                 |
|    weightType              |    wt                | Weight type             |
|    weightName              |    wn                | Weight Name             |
|    warningType             |    wnt               | Warning Type            |
|    customWeights           |    cw                | Custom Weights          |
|    studyTypeId             |    sti               | Study Type ID           |
|    studySource             |    ss                | Study Source            |
|    studyTypeDescription    |    std               | Study Type Description  |
|----------------------------|----------------------|-------------------------|

*/
